export default __webpack_public_path__ + "static/media/messengerBlack.009db47e.png";